import { render, staticRenderFns } from "./page13.vue?vue&type=template&id=402600bf&scoped=true&"
import script from "./page13.vue?vue&type=script&lang=js&"
export * from "./page13.vue?vue&type=script&lang=js&"
import style0 from "./page13.vue?vue&type=style&index=0&id=402600bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402600bf",
  null
  
)

export default component.exports